import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function MaterialReorderThresholdField(props: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}) {
  return (
    <label className="block text-xs text-gray-600 dark:text-zinc-300">
      Reorder quantity
      <input
        className={`${inputClass} mt-1`}
        inputMode="decimal"
        placeholder="e.g. 40"
        value={props.value}
        disabled={props.disabled}
        onChange={(e) => props.onChange(e.target.value)}
      />
      <span className="mt-1 block text-[11px] text-gray-500 dark:text-zinc-400">
        Generate PO → Fill from below-reorder buys enough to reach this qty. Blank means no auto-fill
        for this material.
      </span>
    </label>
  );
}
